import React from "react";
import ReactDOM from "react-dom";
import { Formik, Form, Field } from "formik";
import { ApiService } from "../../../../../services/ApiService";

export default function EditAssigncaseModal({
  closeModal,
  employees,
  cases,
  employee_cases,
  alert,
  value,
}) {
  return (
    <React.Fragment>
      <Formik
        initialValues={{
          edit_case: value.case,
          assigned_to: value.assigned_to,
          edit_penalty: value.penalty,
          case_id: value.id,
          assigned_by: value.assigned_by,
          id: value.id,
        }}
        onSubmit={(values) => {
          ApiService.post(
            `disciplinary-cases/update-assign-case/${values.id}`,
            values
          ).then((res) => {
            if (res.data.type === false) {
              alert.error(res.data.msg);
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
              employee_cases();
              closeModal();
            }
          });
        }}
      >
        {({ handleSubmit, values, isSubmitting }) => (
          <Form>
            <div className="form-group">
              <label>
                {" "}
                cases<span className="text-danger"> * </span>
              </label>
              <Field
                as="select"
                className="form-control"
                id="case"
                name="edit_case"
                required
              >
                <option value="">--Select case--</option>

                {cases.map((cas, i) => (
                  <option value={cas.id} key={i}>
                    {cas.name}
                  </option>
                ))}
              </Field>
            </div>

            <div className="form-group">
              <label>
                Assigned To <span className="text-danger"> * </span>
              </label>
              <Field
                as="select"
                className="form-control"
                name="assigned_to"
                disabled
              >
                <option>--Select Employee--</option>

                {employees.map((employee, i) => (
                  <option value={employee.id} key={i}>
                    {employee.first_name}
                  </option>
                ))}
              </Field>
            </div>
            <div className="form-group">
              <label>
                Assigned By <span className="text-danger"> * </span>
              </label>
              <Field
                as="select"
                className="form-control"
                name="assigned_by"
                disabled
              >
                <option>--Select Employee--</option>

                {employees.map((employee, i) => (
                  <option value={employee.id} key={i}>
                    {employee.first_name}
                  </option>
                ))}
              </Field>
            </div>

            <div className="form-group">
              <label> Penalty</label>
              <Field
                type="text"
                className="form-control"
                id="penalty"
                name="edit_penalty"
                placeholder="Penalty"
                autoComplete="off"
              />
            </div>

            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/employeemanagement/disciplinarycase/modals/edit_assign_case.js